const FALLBACK_PATH = '/';

export function isSafeAuthRedirectPath(value: string): boolean {
	return /^\/(?![/\\])/.test(value);
}

export function safeAuthRedirectPath(value: string | null | undefined): string {
	return value && isSafeAuthRedirectPath(value) ? value : FALLBACK_PATH;
}
